import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { API } from '../../../request/api';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const useHome = (Login) => {
  const params = useParams();
  const paramsArray = getSortedParams(params);
  // eslint-disable-next-line no-unused-vars
  const [banners, setBanners] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sliders, setSliders] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);

  const getCategoryList = () => {
    API.get
      .categories(Login.city_id)
      .then((response) => {
        setCategoryList(response.data);
        let cat_id = null;
        if (response.data[0]) {
          cat_id = paramsArray.length > 0 ? paramsArray[0] : response.data[0].id;
        }
        setActiveCategory(cat_id);
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  // const getBanners = () => {
  //   // const isMobile = (window.innerWidth || 0) < 500;
  //   API.get
  //     .layout(Login.city_id, activeCategory, true, 'home_page')
  //     .then((response) => {
  //       if (response.success) {
  //         const allSliders = response.data.flatMap((item) => item.banners);
  //         setBanners(allSliders);
  //       }
  //       return response;
  //     })
  //     .catch((error) => {
  //       // eslint-disable-next-line no-console
  //       console.error('Error : ', error);
  //     });
  // };

  // const getSliders = () => {
  //   if (activeCategory !== null) {
  //     API.get
  //       .layout(Login.city_id, activeCategory, true)
  //       .then((response) => {
  //         if (response.success) {
  //           const allProductSliders = response.data.flatMap((item) => item.sliders);
  //           setSliders(allProductSliders);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error : ', error);
  //       });
  //   }
  // };

  const getLayoutSections = () => {
    if (activeCategory !== null) {
      API.get
        .layout(Login.city_id, activeCategory, 'home_page', true)
        .then((response) => {
          if (response.success) {
            setLayouts(response.data);
          }
          return response;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error : ', error);
        });
    }
  };

  useEffect(() => {
    if ((Login.city_id || Login.province_id) && activeCategory !== null) {
      // getBanners();
      // getSliders();
      getLayoutSections();
    }
  }, [Login.city_id, Login.province_id, activeCategory]); // eslint-disable-line

  useEffect(() => {
    getCategoryList();
  }, [Login.city_id, Login.province_id]); // eslint-disable-line

  return {
    banners,
    sliders,
    layouts,
    categoryList,
    activeCategory,
    setActiveCategory
  };
};

export default useHome;
